module.exports = __webpack_public_path__ + "static/media/icon-home-menu.dc85e9a2.png";